<template>
  <div class="tags-page">
    <div class="container">
      <div v-if="studyId" class="tags-page__header d-flex">
        <template v-if="this.$route.name == 'data-capture-form-activity-questions'">
          <router-link :to="{ name: 'forms-list' }" class="d-block tags-page__back-to-activities fs-14">Data Capture Forms&nbsp;</router-link>
          <span>/&nbsp;</span>
          <router-link
            class="d-block tags-page__back-to-activities fs-14"
            :to="{
              name: 'data-capture-form-activity-details',
              params: {
                studyId: this.studyId,
                activityId: this.activityId,
                revisionId,
                mode: this.mode
              },
              query: { revisionId: revisionId, mode: mode }
            }"
            >Activity Information&nbsp;</router-link
          >
        </template>
        <template v-else>
          <router-link
            :to="{
              name: 'study-activities',
              params: { studyId, mode }
            }"
            class="d-block tags-page__back-to-activities fs-14"
            >Activities&nbsp;</router-link
          >
          <span>/&nbsp;</span>
          <router-link
            class="d-block tags-page__back-to-activities fs-14"
            :to="{
              name: 'activity-details',
              params: { activityId, mode, studyId },
              query: { revisionId: revisionId, mode: mode }
            }"
            >Activity Information&nbsp;</router-link
          >
        </template>

        <span>/ Create Activity</span>
      </div>
      <div v-else class="tags-page__header d-flex">
        <router-link :to="{ name: 'activity-library-homepage' }" class="d-block tags-page__back-to-activities fs-14">Activity Library&nbsp;</router-link>
        <span>/&nbsp;</span>
        <router-link class="d-block tags-page__back-to-activities fs-14" :to="{ name: 'activity-details', params: { activityId: activityId } }"> Activity Information&nbsp;</router-link>
        <span>/ Activity Configurator</span>
      </div>

      <div :class="showPreview == true || showLogic === true ? 'col-lg-9 survey_instruction_question' : 'col-lg-12 suvey_question_card'">
        <div class="mt-30 container-style mb-30">
          <div class="p-20">
            <div class="row">
              <div class="col-lg-4 p-0">
                <img class="float-left mt-10 mr-5" src="static/img/activity-configurator/activity-frame-step.svg" />
                <div class="fw-500 fs-20 pt-5">Create Activity - {{ activityData.name }}</div>
              </div>

              <div class="col-lg-8 p-0">
                <div class="float-right mb-18 pl-5">
                  <button type="button" class="btn btn-md btn-block br-5" :class="showDeleteButton ? 'group-scoring-enabled' : 'group-scoring-disabled'" @click="addQuestion ? (showDeleteButton = false) : (showDeleteButton = !showDeleteButton)">
                    <span :class="showDeleteButton ? 'hide-circle' : 'show-circle'">
                      <i v-if="showDeleteButton == false" class="mb-4 fa fa-trash"></i>
                      <i v-if="showDeleteButton == true" class="fa fa-trash"></i>
                    </span>
                    <span v-if="showDeleteButton == false" class="show-txt ml-5">Delete Steps</span>
                    <span v-if="showDeleteButton" class="hide-txt ml-5" style="color: #ffffff;">Delete Steps</span>
                  </button>
                </div>
                <div v-if="showPreview === false" class="float-right mb-18 pl-5">
                  <button type="button" class="button2 btn btn-md btn-block show-btn-preview" v-on:click="togglePreview()">
                    <span class="show-circle">
                      <img src="static/img/surveyPreview/show.png" class="mb-4" />
                    </span>
                    <span class="show-txt ml-5">Show Preview</span>
                  </button>
                </div>

                <div v-if="showPreview === true" class="float-right mb-18 pl-10">
                  <button type="button" v-on:click="togglePreview()" class="button2 btn btn-md btn-block btn-preview">
                    <span class="hide-circle">
                      <img src="static/img/surveyPreview/hide.png" class="mb-4" />
                    </span>
                    <span class="hide-txt ml-5" style="color: #ffffff;">Hide Preview</span>
                  </button>
                </div>
                <div v-if="showLogic === false" class="float-right mb-18">
                  <button type="button" class="button2 btn btn-md btn-block show-btn-preview" v-on:click="toggleLogic()">
                    <span class="show-circle">
                      <img src="static/img/activity-configurator/activity-show-logic.svg" />
                    </span>
                    <span class="show-txt ml-5">Show Logic</span>
                  </button>
                </div>
                <div v-if="showLogic === true" class="float-right mb-18">
                  <button type="button" v-on:click="toggleLogic()" class="button2 btn btn-md btn-block btn-preview">
                    <span class="hide-circle">
                      <img src="static/img/activity-configurator/activity-hide-logic.svg" />
                    </span>
                    <span class="hide-txt ml-5" style="color: #ffffff;">Hide Logic</span>
                  </button>
                </div>
                <div class="float-right mb-18 pr-5">
                  <button type="button" class="btn btn-md btn-block br-5" :class="isGroupScoringInEditMode ? 'group-scoring-enabled' : 'group-scoring-disabled'" v-on:click="toggleGroupScoringEditMode">
                    <span :class="isGroupScoringInEditMode ? 'hide-circle' : 'show-circle'">
                      <img v-if="isGroupScoringInEditMode == false" src="static/img/activity-configurator/activity-group-scoring-selected.png" class="mb-4" />
                      <img v-if="isGroupScoringInEditMode == true" src="static/img/activity-configurator/activity-group-scoring-not-selected.png" />
                    </span>
                    <span v-if="isGroupScoringInEditMode==false" class="show-txt ml-5">Sections</span>
                    <span v-if="isGroupScoringInEditMode" class="hide-txt ml-5" style="color: #ffffff;">Sections</span>
                  </button>
                </div>
                <div class="float-right mb-18 pr-5" v-if="activityData.canScoreResponses">
                  <button type="button" class="btn btn-md btn-block br-5 group-scoring-disabled" @click="redirectToAdvancedScoring">
                     <span class="show-circle">
                      <img src="static/img/activity-configurator/advanced-scoring.png" class="mb-4" />
                    </span>
                    <span id="advanced-scoring-button" class="show-txt ml-5">Advanced Scoring</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <!------Preview Button END------>
              <readOnlyQuestions
                class
                :activityId="activityId"
                :questions="questionAnswers"
                :activityData="activityData"
                @editedEvent="questionIsEdited"
                :isGroupScoringInEditMode="isGroupScoringInEditMode"
                :hideEditBtn="false"
                @onSectionAddEdit="onSectionAdd"
                :activeEditGroup.sync="activeEditGroup"
                :batchDeleteQuestions="batchDeleteQuestions"
                :showDeleteButton="showDeleteButton"
                @update-delete-flag="updateDeleteFlag"
              >
                <template slot="section">
                  <div v-if="activeEditGroup && 1 === 0">
                    <addEditQuestion :options="activeEditGroup" :activityData="activityData"></addEditQuestion>
                  </div>
                </template>
              </readOnlyQuestions>
              <div v-if="addQuestion && !isQuestionInEditMode" :id="`add-edit-question`">
                <addEditQuestion :options="sampleQuestion" :addQuestion="addQuestion" :isQuestionInEditMode="isQuestionInEditMode" :activityData="activityData" @onCancelAfterAutoSave="getActivityDetails"></addEditQuestion>
              </div>
              <!--Phone frame design ---->
            </div>
            <div class="row pt-10" v-if="questionAnswers.length > 0">
              <div v-if="!showDeleteButton">
                <div class="col-lg-1 col-md-2 col-sm-3 p-0">
                  <button :disabled="this.questionAnswers.some(obj => obj.subtype == 'custom')" type="button" class="btn btn-md btn-block add_another_btn br-25 btn-new" v-on:click="addNewStep()">
                    <span class="circle">+</span>
                    <span class="txt">Add a Step</span>
                  </button>
                </div>
              </div>
              <div v-else-if="showDeleteButton">
                <div class="float-right mb-18">
                  <button type="button" class="btn-delete btn btn-md btn-block br-25" v-on:click="checkBranchingLogic()" :disabled="!this.batchDeleteQuestions.length">
                    <span class="delete-circle"><i class="fa fa-trash"></i></span>
                    <span class="txt" style="color:#fff;left:0px;">Delete Selected Steps</span>
                  </button>
                </div>
                <div class="float-right mb-18">
                  <button
                    :disabled="!this.batchDeleteQuestions.length"
                    type="button"
                    class="cancel-btn"
                    v-on:click="
                      showDeleteButton = false;
                      batchDeleteQuestions = [];
                    "
                  >
                    <span class="cancel-btn-text">Cancel</span>
                  </button>
                </div>
              </div>
            </div>
            <div v-if="!showDeleteButton" class="row">
              <div class="float-right mb-18">
                <button type="button" class="continue-btn" v-on:click="createActivitySteps()">
                  <span class="continue-btn-text">Continue</span>
                </button>
              </div>
              <div class="float-right mb-18">
                <button type="button" class="cancel-btn" v-on:click="skipForNow()">
                  <span class="cancel-btn-text">Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showPreview === true" class="col-lg-3 pl-0 pr-3 container-stylee">
        <deviceQuestionsView
          class
          :intrupted="intrupted"
          @resetIntrupt="intrupted = false"
          @isProcessing="
            val => {
              isExporting = val;
            }
          "
          :questions="questionAnswers"
          :activityData="activityData"
          @editedEvent="questionIsEdited"
        ></deviceQuestionsView>
      </div>
      <div v-if="isExporting" @click="intrupted = true" class="loader">
        <div class="loader-container">
          <p><b>Processing</b></p>
          <i class="fa fa-spinner fa-spin"></i>
        </div>
      </div>
      <div v-if="showLogic === true" class="col-lg-3 pl-3 container-style-logic">
        <nav class="navbar navbar-expand-sm" style="padding:20px;border-bottom: 1px solid #eee;display:block;">
          <div class="text-center">
            <div class="btn-group m-b-10 phoneTabletMenu">
              <span class="branching-logic-text">Branching Logic</span>
            </div>
          </div>
        </nav>
        <div id="logic-frame">
          <div class="logic-frame1">
            &nbsp;
            <div class="logical-frame-section" v-for="(question, index) in questionAnswers.filter(questionAnswer => questionAnswer.type !== 'SurveyCompletion' && questionAnswer.type !== 'Section')" :key="index">
              <div class="row">
                <div class="pl-15">
                  <span class="question_color">
                    Step
                    <span class>{{ question.stepSequence }}:</span>
                  </span>
                </div>
                <div v-if="question.type === 'SurveyInstruction'" class="pl-15 show-logic-questions-wrap">
                  <div class="branching-question-name" v-html="question.title"></div>
                  <div class="branching-steps-wrap">
                    <div class="instruction_info" v-html="question.information"></div>
                    <div class="line"></div>
                    <div class="logic-box" :class="logicTextToClassMap[getBranchingInformationForQuestion(question)] ? logicTextToClassMap[getBranchingInformationForQuestion(question)] : 'logic-box-skip-back-activity'">
                      <span class="logic-box-text">{{ getBranchingInformationForQuestion(question) }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="question.type === 'ImageCapture'" class="pl-15 show-logic-questions-wrap">
                  <div class="branching-question-name" v-html="question.title"></div>
                  <div class="branching-steps-wrap">
                    <div class="instruction_info" v-html="question.information"></div>
                    <div class="line"></div>
                    <div class="logic-box">
                      <span class="logic-box-text">No logic</span>
                    </div>
                  </div>
                </div>
                <div v-if="question.type === 'Log'" class="pl-15 show-logic-questions-wrap">
                  <div class="branching-question-name" v-html="question.body"></div>
                  <div class="branching-steps-wrap">
                    <div class="any-answer-label">
                      <label class="branching-logic-answer-label float-left">Answer</label>
                    </div>
                    <div class="line"></div>
                    <div class="logic-box">
                      <span class="logic-box-text">No logic</span>
                    </div>
                  </div>
                </div>
                <div v-if="question.type.toLowerCase() === 'gpskin' || question.type.toLowerCase() === 'wongbaker'" class="pl-15 show-logic-questions-wrap">
                  <div class="branching-question-name" v-html="question.formattedTitle"></div>
                  <div class="branching-steps-wrap">
                    <div class="any-answer-label">
                      <label class="branching-logic-answer-label float-left">Answer</label>
                    </div>
                    <div class="line"></div>
                    <div class="logic-box">
                      <span class="logic-box-text">No logic</span>
                    </div>
                  </div>
                </div>
                <div v-if="question.type.toLowerCase() === 'numberscale' || question.type.toLowerCase() === 'customscale' || (question.type === 'Number' && question.branchingType === 'advance')" class="pl-15 show-logic-questions-wrap">
                  <div class="clearfix"></div>
                  <div v-if="question.branchingConfigured">
                    <div class="branching-question-name mb-10" v-html="question.body"></div>
                    <div class="branching-steps-wrap" v-for="(branchingoption, index) in zip(getBranchingInformationForQuestion(question), question.branchingOptions)" :key="index">
                      <span>
                        <template v-if="branchingoption[1].endValue">
                          <div class="branching-logic-answer-label float-left">
                            {{ branchingoption[1].startValue }} to
                            {{ branchingoption[1].endValue }}
                          </div>
                        </template>
                        <template v-if="branchingoption[1].type === 'single'">
                          <div class="branching-logic-answer-label float-left">
                            {{ branchingoption[1].singleValue }}
                          </div>
                        </template>
                      </span>
                      <span class="line"></span>
                      <div class="" :class="logicTextToClassMap[branchingoption[0]] ? logicTextToClassMap[branchingoption[0]] : 'logic-box-skip-back-activity'">
                        <span class="logic-box-text">{{ branchingoption[0] }}</span>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
                <div class="pl-15" v-else-if="question.type === 'Image'">
                  <span class="branching-question-name" v-html="question.body"></span>
                  <div class="clearfix"></div>
                  <div class>
                    <div class="branching-steps-wrap" v-for="(option, index) in zip(getBranchingInformationForQuestion(question), question.languageImageOptions[0].options)" :key="index">
                      <img :src="option[1] && option[1].imageUrl" alt class="wid300 img-size" />
                      <div class="line"></div>
                      <div :class="logicTextToClassMap[option[0]] ? logicTextToClassMap[option[0]] : 'logic-box-skip-back-activity'">
                        <span class="logic-box-text">{{ option[0] }}</span>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>

                <div class="pl-15" v-if="question.type == 'MultiChoice' && question.branchingConfigured === false">
                  <p class="branching-question-name" v-html="question.body"></p>
                  <div class="answer-show-logic branching-steps-wrap" v-for="(option, index) in zip(getBranchingInformationForQuestion(question), question.options)" :key="index">
                    <label class="branching-logic-answer-label float-left multichoice-ans">{{ option[1] && option[1].body }}</label>
                    <div class="line"></div>
                    <div>
                      <span class="logic-box logic-box-update">No Logic</span>
                    </div>
                  </div>
                </div>

                <div class="pl-15" v-if="question.type === 'Number' && question.branchingConfigured === false">
                  <p class="branching-question-name" v-html="question.body"></p>
                  <div class="answer-show-logic branching-steps-wrap">
                    <label class="branching-logic-answer-label float-left">Answer</label>
                    <div class="line"></div>
                    <div>
                      <span class="logic-box logic-box-update">No Logic</span>
                    </div>
                  </div>
                </div>

                <div class="pl-15 show-logic-questions-wrap" v-if="question.type == 'Text' || (question.type === 'Number' && question.branchingType === 'normal' && question.branchingConfigured == true)">
                  <div class="branching-question-name" v-html="question.body" />
                  <div class="branching-steps-wrap">
                    <div class="any-answer-label">
                      <label class="branching-logic-answer-label float-left">Any answer</label>
                    </div>
                    <div class="line"></div>
                    <div class="step-output-box">
                      <div class="branching-text-normal" :class="logicTextToClassMap[findStepSequence(question)] ? logicTextToClassMap[findStepSequence(question)] : 'logic-box-skip-back-activity'">
                        <span class="logic-box-text">{{ findStepSequence(question) }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pl-15" v-else-if="(question.type == 'MultiChoice' && question.branchingConfigured === true && question.multipleSelection === false) || question.type == 'Boolean' || question.type == 'DropDown'">
                  <p class="branching-question-name" v-html="question.body"></p>
                  <div class="answer-show-logic branching-steps-wrap" v-for="(option, index) in zip(getBranchingInformationForQuestion(question), question.options)" :key="index">
                    <label class="branching-logic-answer-label float-left multichoice-ans">{{ option[1] && option[1].body }}</label>
                    <div class="line"></div>
                    <div :class="logicTextToClassMap[option[0]] ? logicTextToClassMap[option[0]] : 'logic-box-skip-back-activity'">
                      <span class="logic-box-text">{{ option[0] }}</span>
                    </div>
                  </div>
                  <div class="instruction_info" v-html="question.formattedInformation"></div>
                </div>
                <div v-if="question.type === 'DateTime'" class="pl-15 show-logic-questions-wrap">
                  <div class="branching-question-name" v-html="question.body"></div>
                  <div class="branching-steps-wrap">
                    <div class="any-answer-label">
                      <label class="branching-logic-answer-label float-left">Any answer</label>
                    </div>
                    <div class="line"></div>
                    <div class="logic-box" :class="logicTextToClassMap[getBranchingInformationForQuestion(question)] ? logicTextToClassMap[getBranchingInformationForQuestion(question)] : 'logic-box-skip-back-activity'">
                      <span class="logic-box-text">{{ getBranchingInformationForQuestion(question) }}</span>
                    </div>
                  </div>
                </div>
                <div class="pl-15 show-logic-questions-wrap" v-else-if="question.type == 'Index' || question.type == 'VAS' || question.type == 'Measurements' || question.type.toLowerCase() === 'validatedentry' || question.type == 'MedicationSelector'">
                  <div class="branching-question-name" v-html="question.body" />
                  <div class="branching-steps-wrap">
                    <div class="any-answer-label">
                      <label class="branching-logic-answer-label float-left">Answer</label>
                    </div>
                    <div class="line"></div>
                    <div class="logic-box">
                      <span class="logic-box-text">No logic</span>
                    </div>
                  </div>
                </div>
                <div class="pl-15 show-logic-questions-wrap" v-if="(question.type.toLowerCase() === 'numberscale' || question.type.toLowerCase() === 'customscale') && !question.branchingConfigured">
                  <div class="branching-question-name" v-html="question.body" />
                  <div class="branching-steps-wrap">
                    <div class="any-answer-label">
                      <label class="branching-logic-answer-label float-left">Answer</label>
                    </div>
                    <div class="line"></div>
                    <div class="logic-box">
                      <span class="logic-box-text">No logic</span>
                    </div>
                  </div>
                </div>
                <div class="pl-15 show-logic-questions-wrap" v-if="question.type.toLowerCase() === 'audiorecording' || question.type.toLowerCase() === 'videorecording'">
                  <div class="branching-question-name" v-html="question.formattedTitle" />
                  <div class="branching-steps-wrap">
                    <div class="any-answer-label">
                      <label class="branching-logic-answer-label float-left">Answer</label>
                    </div>
                    <div class="line"></div>
                    <div class="logic-box">
                      <span class="logic-box-text">No Logic</span>
                    </div>
                  </div>
                </div>
                <div class="pl-15 show-logic-questions-wrap" v-if="question.type.toLowerCase() === 'skinanalyser'">
                  <div class="branching-question-name" v-html="question.formattedTitle" />
                  <div class="branching-steps-wrap">
                    <div class="any-answer-label">
                      <label class="branching-logic-answer-label float-left">Answer</label>
                    </div>
                    <div class="line"></div>
                    <div class="logic-box">
                      <span class="logic-box-text">No Logic</span>
                    </div>
                  </div>
                </div>
                <div class="pl-15 show-logic-questions-wrap" v-if="question.branchingConfigured === true && question.type === 'MultiChoice' && question.multipleSelection === true && question.recursiveBranching === false">
                  <div class="branching-question-name mb-10" v-html="question.body"></div>
                  <div v-for="(option, index) in question.branchingOptions" :key="index">
                    <div class="branching-steps-wrap" v-if="option.optionIds && option.optionIds !== ''">
                      <span v-if="option.optionIds.length" class="selected-options-chips selected-multichoice">
                        <span v-for="(opt, optIndex) in option.optionIds.filter((op, opIndex) => opIndex < option.chipsLimitBy)" :id="`branching-opt-${opt.id}-${optIndex}`" :key="`branching-opt-${opt.id}-${optIndex}`" class="chip chip-multiselect">
                          {{ opt.body }}{{ " " }}
                          <span class="and-sec" v-if="optIndex !== option.optionIds.length - 1">and</span>
                        </span>
                        <a href="javascript:void(0)" v-if="option.optionIds.length > 6" class="see-more-less" @click="toggleChips(option)">{{ option.chipsLimitBy === 6 ? "See more" : "See less" }}</a>
                      </span>
                      <span class="line"></span>
                      <span class="branching-text branching-text-left" :class="logicTextToClassMap[findStepSequence(option)] ? logicTextToClassMap[findStepSequence(option)] : 'logic-box-skip-back-activity'">
                        <span class="logic-box-text">{{ findStepSequence(option) }}</span></span
                      >
                    </div>
                  </div>
                </div>

                <div class="pl-15 show-logic-questions-wrap" v-if="question.type === 'MultiChoice' && question.multipleSelection === true && question.recursiveBranching === true && question.branchingConfigured === true">
                  <div class="branching-question-name mb-10" v-html="question.body"></div>
                  <div v-for="(option, index) in question.options" :key="index">
                    <div class="branching-steps-wrap">
                      <span class="multiValue-data selected-multichoice">
                        <span class="branching-text-val">{{ option.body }}</span>
                      </span>
                      <span class="line"></span>
                      <div>
                        <span v-if="option.nextQuestionIdList.length === 0" class="logic-box logic-box-update">No logic</span>

                        <span v-else>
                          <span v-if="option.nextQuestionIdList.length" class="selected-recursive-chips selected-multichoice-recursive">
                            <div v-for="(opt, optIndex) in option.nextQuestionIdList.filter((op, opIndex) => opIndex < option.chipsLimitBy)" :id="`branching-opt-${opt.id}-${optIndex}`" :key="`branching-opt-${opt.id}-${optIndex}`" class="chip chip-recursive">
                              <span class="logic-box-text">{{ findStepSequenceRecursive(opt) }}</span>
                              {{ " " }}<span v-if="optIndex !== option.nextQuestionIdList.length - 1">,</span>
                            </div>
                            <a href="javascript:void(0)" v-if="option.nextQuestionIdList.length > 6" class="see-more-less" @click="toggleChipsRecursive(option)">{{ option.chipsLimitBy === 6 ? "See more" : "See less" }}</a>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p>
                      <span>Once recursive loop is complete, </span>
                      <span class="end-recursive-step">{{ findStepSequenceRecursive(question.recursiveLoopEndQuestionId) }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from "toastr";
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import _ from "lodash";
import $ from "jquery";
import sampleQuestionObj from "../survey-builder/surveyQuestion.json";
import sampleSectionObj from "@/constants/activity-library-and-configurator-component/activityGroup";
import addEditQuestion from "./activity-add-edit-question";
import readOnlyQuestions from "./activity-read-only-questions";
import deviceQuestionsView from "./activity-device-view";
import swal from "sweetalert2";
import * as commonHelper from "@/components/services/common-helper";
import * as activityService from "@/components/services/activity-service";

export default {
  name: "activityquestions",
  data() {
    return {
      intrupted: false,
      isExporting: false,
      showTime: null,
      showDate: null,
      units: null,
      minValue: null,
      maxValue: null,
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      },
      piecewiseActiveStyle: {
        backgroundColor: "#3498db"
      },
      labelActiveStyle: {
        color: "#3498db"
      },
      activityTypes: [],
      showLogic: false,
      showPreview: false,
      showTablet: false,
      showDownloadVideoScreen: false,
      id: null,
      activityId: null,
      revisionId: null,
      studyId: null,
      activityDataOld: null,
      activityData: { title: "", nickName: "", questions: [], rows: [] },
      addQuestion: false,
      scaleValueInfoDiv: false,
      sequence: 1,
      currentIndex: 0,
      phoneQuestion: null,
      nextQuestion: null,
      updateActivityData: null,
      questionAnswers: [],
      questionsWithoutCompletion: [],
      introQuestions: [],
      sampleQuestion: null,
      selectedActivityQuestion: { value: "Default", label: "- Select -" },
      isQuestionInEditMode: false,
      isGroupScoringInEditMode: false,
      sampleSectionObj,
      activeEditGroup: null,
      zip: _.zip,
      taskId: null,
      logicTextToClassMap: {
        "No logic": "logic-box",
        "End activity": "logic-box-end-activity"
      },
      mode: "",
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT,
      batchDeleteQuestions: [],
      showDeleteButton: false,
      multipleChoiceBranchingOptions: {
        chipsLimitBy: 6
      },
      default_chips_limit: 6
    };
  },
  components: {
    readOnlyQuestions,
    addEditQuestion,
    deviceQuestionsView
  },
  computed: {
    activityRowsChanged() {
      return this.$store.getters.getActivityRows;
    },
    activityDataChanged() {
      return _.cloneDeep(this.$store.getters.getActivityDetails);
    },
    questionSaveUpdateChanged() {
      return this.$store.getters.getNewActivityQuestion;
    },
    selectedActivityQuestionChanged() {
      return this.$store.getters.getActivitySelectedQuestion;
    },
    activityQuestions() {
      return this.$store.getters.getActivityQuestionsData;
    }
  },
  mounted() {
    this.activityId = this.$route.params.activityId;
    this.revisionId = this.$route.params.revisionId ? this.$route.params.revisionId : this.$route.query.revisionId;
    this.studyId = this.$route.params.studyId ? this.$route.params.studyId : this.$route.query.studyId;
    this.mode = this.$route.params.mode ? this.$route.params.mode : this.$route.query.mode;
    this.taskId = this.$route.params.taskId;
    this.getActivityDetails();
    this.getActivityTypes();
    this.startAutoSave();
  },
  watch: {
    questionSaveUpdateChanged: {
      handler(val) {
        if (val) {
          const questionObj = val;
          if (questionObj && questionObj.showTimeRange && questionObj.timeRange == 1) {
            questionObj.startTime = "";
            questionObj.endTime = "";
          }
          if (questionObj && questionObj.showTimeRange && questionObj.timeRange == 0) {
            questionObj.hoursBefore = null;
            questionObj.hoursAfter = null;
          }
          const questionType = questionObj.type === "Section" ? "Section" : "Question";
          if (val.opType === "delete") {
            this.$api.deleteActivityQuestionFact(this.activityId, val.id).then(() => {
              if (questionType == "Section") {
                toastr.success("Section deleted successfully");
              } else {
                toastr.success("Question deleted successfully");
              }
              this.$store.dispatch("setLastModifiedActivityQuestion", questionObj);
              const questionIndex = _.findIndex(this.questionAnswers, ["id", val.id]);
              this.questionAnswers.splice(questionIndex, 1);
              this.questionAnswers = this.getOrderedStepSequence(this.questionAnswers);
              this.pushCompletionQuestion();
              this.$store.dispatch("selectedActivityQuestionAction", {
                id: null
              });
              this.$api.updateActivityQuestionOrderFact(this.activityId, this.questionAnswers).then(
                response => {
                  this.activityData = response.body.result;
                  this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
                },
                error => {
                  this.errorMsg = error.body ? error.body.message : "Error while changing order";
                }
              );
              if (this.questionAnswers && this.questionAnswers.length === 0) {
                this.addQuestion = true;
                this.sampleQuestion = _.cloneDeep(JSON.parse(JSON.stringify(sampleQuestionObj))); //eslint-disable-line
                this.sampleQuestion.sequence = 1;
              } else {
                this.addQuestion = false;
                this.isQuestionInEditMode = false;
              }
            });
          } else if (!val.id) {
            if (!questionObj.isSkippable) {
              questionObj.skipScore = undefined;
            }
            // Question with out id === new question
            questionObj.sequence = !val.sequence ? Number(_.max(_.map(this.questionsWithoutCompletion, "sequence"))) + 1 : val.sequence;

            questionObj.branchingConfigured = this.toggleBranchingConfiguration(questionObj);

            delete questionObj.questionNumber;
            if (questionType == "Section"){
              questionObj.weight = undefined;
            }
            this.$api.addActivityQuestionFact(this.activityId, questionObj).then(
              response => {
                if (val.autoSave) {
                  this.sampleQuestion.id = response.body.result.id;
                } else {
                  this.getActivityDetails();
                }
                this.$store.dispatch("setLastModifiedActivityQuestion", questionObj);
                this.$store.dispatch("addActivityQuestionAction", null);

                // By default new question gets added at bottom, for section we have to insert in between
                if (questionType === "Section") {
                  this.questionAnswers.splice(response.data.result.sequence - 1, 0, response.data.result);
                  this.questionsWithoutCompletion.splice(response.data.result.sequence - 1, 0, response.data.result);
                  this.$store.dispatch("selectedActivityQuestionAction", {
                    id: null
                  });
                } else {
                  this.questionAnswers.push(response.data.result);
                  this.questionsWithoutCompletion.push(response.data.result);
                }
                this.activityData.questions = this.questionAnswers;
                this.$store.dispatch("setActivityDetailsAction", this.activityData);
                this.pushCompletionQuestion();
                this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
                if (!val.autoSave) {
                  this.addQuestion = false;
                  this.isQuestionInEditMode = false;
                  this.sequence = this.sequence + 1;
                  toastr.success(`${questionType} added successfully`);
                }
              },
              error => {
                this.$root.$emit('addSectionFailed',true);
                this.$store.dispatch("addActivityQuestionAction", null);
                if (!val.autoSave) {
                  this.errorMsg = error.body ? error.body.message : `Error while adding the ${questionType}`;
                  toastr.error(this.errorMsg);
                }
              }
            );
          } else {
            // Question with id === existing question
            questionObj.branchingConfigured = this.toggleBranchingConfiguration(questionObj);
            delete questionObj.questionNumber;

            if (this.updateActivityData != null) {
              if (questionType == "Section"){
                questionObj.weight = undefined;
              }
              if (!questionObj.isSkippable) {
                questionObj.skipScore = undefined;
              }
              questionObj.multipleSelection = questionObj.hasOwnProperty("multipleSelection") ? questionObj.multipleSelection : false;
              this.updateActivityOldData(this.updateActivityData).then(response => {
                this.$api.updateActivityQuestionFact(this.activityId, questionObj.id, questionObj).then(
                  response => {
                    this.$store.dispatch("setLastModifiedActivityQuestion", questionObj);
                    if (val.autoSave && this.isQuestionInEditMode) {
                      this.getActivityDetails();
                    }
                    if (!val.autoSave) {
                      this.getActivityDetails();
                      toastr.success(`${questionType} updated successfully`);

                      const questionIndex = _.findIndex(this.questionAnswers, ["id", response.data.result.id]);
                      this.questionAnswers.splice(questionIndex, 1, response.data.result);
                      const questionIndexComplete = _.findIndex(this.questionsWithoutCompletion, ["id", response.data.result.id]);
                      this.questionsWithoutCompletion.splice(questionIndexComplete, 1, response.data.result);
                      this.activityData.questions = this.questionAnswers;
                      this.$store.dispatch("setActivityDetailsAction", this.activityData);
                      this.$store.dispatch("selectedActivityQuestionAction", {
                        id: null
                      });
                      this.pushCompletionQuestion();
                      this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
                      this.addQuestion = false;
                      this.isQuestionInEditMode = false;
                    }
                  },
                  error => {
                    this.$store.dispatch("selectedActivityQuestionAction", {
                      id: null
                    });
                    if (!val.autoSave) {
                      this.errorMsg = error.body ? error.body.message : `Error while updating the ${questionType}`;
                      toastr.error(this.errorMsg);
                    }
                  }
                );
              });
            } else {
              if (questionType == "Section"){
                questionObj.weight = undefined;
              }
              if (!questionObj.isSkippable) {
                questionObj.skipScore = undefined;
              }
              questionObj.multipleSelection = questionObj.hasOwnProperty("multipleSelection") ? questionObj.multipleSelection : false;
              this.$api.updateActivityQuestionFact(this.activityId, questionObj.id, questionObj).then(
                response => {
                  this.$store.dispatch("setLastModifiedActivityQuestion", questionObj);
                  if (val.autoSave && this.isQuestionInEditMode) {
                    this.getActivityDetails();
                  }
                  if (!val.autoSave) {
                    this.getActivityDetails();
                    toastr.success(`${questionType} updated successfully`);
                    const questionIndex = _.findIndex(this.questionAnswers, ["id", response.data.result.id]);
                    this.questionAnswers.splice(questionIndex, 1, response.data.result);
                    const questionIndexComplete = _.findIndex(this.questionsWithoutCompletion, ["id", response.data.result.id]);
                    this.questionsWithoutCompletion.splice(questionIndexComplete, 1, response.data.result);
                    this.activityData.questions = this.questionAnswers;
                    this.$store.dispatch("setActivityDetailsAction", this.activityData);
                    this.$store.dispatch("selectedActivityQuestionAction", {
                      id: null
                    });
                    this.pushCompletionQuestion();
                    this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
                    this.addQuestion = false;
                    this.isQuestionInEditMode = false;
                  }
                },
                error => {
                  this.$root.$emit('addSectionFailed',true);
                  this.$store.dispatch("selectedActivityQuestionAction", {
                    id: null
                  });
                  if (!val.autoSave) {
                    this.errorMsg = error.body ? error.body.message : `Error while updating the ${questionType}`;
                    toastr.error(this.errorMsg);
                  }
                }
              );
            }
          }
        }
      }
    },
    selectedActivityQuestionChanged: {
      handler(val) {
        if (val.op === "delete") {
          this.$api.deleteActivityQuestionFact(this.activityId, val.id).then(
            () => {
              toastr.success("Question deleted successfully");
              this.$store.dispatch("setLastModifiedActivityQuestion", null);
              const questionIndex = _.findIndex(this.questionAnswers, ["id", val.id]);
              const questionIndexComplete = _.findIndex(this.questionsWithoutCompletion, ["id", val.id]);
              this.questionAnswers.splice(questionIndex, 1);
              this.questionsWithoutCompletion.splice(questionIndexComplete, 1);

              this.activityData.questions = this.questionAnswers;
              this.pushCompletionQuestion();
              this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
              this.addQuestion = false;
              this.isQuestionInEditMode = false;
            },
            error => {
              this.errorMsg = error.body ? error.body.message : "Erorr while deleting the question";
              toastr.error(this.errorMsg);
            }
          );
        } else {
          this.selectedActivityQuestion = {
            value: "Default",
            label: "- Select -"
          };
          if (val.id) {
            this.addQuestion = true;
          } else {
            this.addQuestion = false;
            this.isQuestionInEditMode = false;
          }
        }
      }
    },
    activityQuestions: {
      handler(val) {
        this.questionAnswers = val;
      }
    },
    activityRowsChanged: {
      deep: true,
      handler(val) {
        if (_.cloneDeep(val.rows) !== _.cloneDeep(this.activityData.rows)) {
          this.updateActivityData = val;
          this.updateActivityOldData(this.updateActivityData).then(() => {
            this.getActivityDetails();
            this.updateActivityData = null;
          });
        } else {
          this.updateActivityData = null;
        }
      }
    }
  },
  methods: {
    redirectToAdvancedScoring(){
      let variableListActivityId = this.activityData && this.activityData.activityId;
      this.$router.push({
        name: "activity-advanced-scoring",
        params: { activityId: this.activityId},
        query: { routeActivityId: variableListActivityId, studyId: this.studyId },
      });
      this.$store.state.advancedScoringSteps = this.activityData;
    },
    getActivityTypes() {
      this.$api
        .getActivityTypes()
        .then(response => {
          this.activityTypes = response.data.result;
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },
    getPlaceHolderText(question) {
      if (question.type == "DateTime") {
        return "Enter a date and a time";
      } else if (question.type == "Number") {
        return "Enter a number";
      } else if (question.type == "Text") {
        return "Answer";
      }
    },
    findStepSequence(question) {
      return commonHelper.branchingLogicRecursive(question.nextQuestionId, this.questionAnswers);
    },
    findStepSequenceRecursive(stepId) {
      return commonHelper.branchingLogicRecursive(stepId, this.questionAnswers);
    },
    toggleChips(option) {
      const optionsLength = option.optionIds.length;
      option.chipsLimitBy = option.chipsLimitBy === this.default_chips_limit ? optionsLength : this.default_chips_limit;
    },
    toggleChipsRecursive(option) {
      const optionsLength = option.nextQuestionIdList.length;
      option.chipsLimitBy = option.chipsLimitBy === this.default_chips_limit ? optionsLength : this.default_chips_limit;
    },
    getBranchingInformationForQuestion(question) {
      const activityCompletionQuestion = this.questionAnswers.find(q => q.type == "SurveyCompletion");
      if (question.type == "SurveyInstruction" || question.type == "DateTime") {
        if (!question.branchingConfigured) {
          return "No logic";
        }
        const nextQuestion = this.questionAnswers.find(q => q.id == question.nextQuestionId);
        if (nextQuestion) {
          if (activityCompletionQuestion && nextQuestion.id == activityCompletionQuestion.id) {
            return "End activity";
          }
          const ordertext = question.stepSequence > nextQuestion.stepSequence ? "Back" : "Skip";
          return `${ordertext} to step ${nextQuestion.stepSequence}`;
        } else {
          return "No logic";
        }
      } else if (question.type == "MultiChoice" || question.type == "Boolean" || question.type == "DropDown") {
        return question.options.map(option => {
          if (!question.branchingConfigured) {
            return "No logic";
          }
          if (option.nextQuestion == "default" || !option.nextQuestion) {
            return "No logic";
          }
          const nextQuestion = this.questionAnswers.find(q => q.id == option.nextQuestion);
          if (nextQuestion) {
            if (activityCompletionQuestion && nextQuestion.id == activityCompletionQuestion.id) {
              return "End activity";
            }
            const ordertext = question.stepSequence > nextQuestion.stepSequence ? "Back" : "Skip";
            return `${ordertext} to step ${nextQuestion.stepSequence}`;
          } else {
            return "No logic";
          }
        });
      } else if (question.type == "Image") {
        return question.languageImageOptions[0].options.map(option => {
          if (!question.branchingConfigured) {
            return "No logic";
          }
          if (option.nextQuestion == "default" || !option.nextQuestion) {
            return "No logic";
          }
          const nextQuestion = this.questionAnswers.find(q => q.id == option.nextQuestion);
          if (nextQuestion) {
            if (activityCompletionQuestion && nextQuestion.id == activityCompletionQuestion.id) {
              return "End activity";
            }
            const ordertext = question.stepSequence > nextQuestion.stepSequence ? "Back" : "Skip";
            return `${ordertext} to step ${nextQuestion.stepSequence}`;
          } else {
            return "No logic";
          }
        });
      } else if (question.type == "NumberScale" || question.type == "CustomScale" || (question.type === "Number" && question.branchingType === "advance")) {
        if (question.branchingOptions) {
          return question.branchingOptions.map(option => {
            if (option.nextQuestionId == "default" || !option.nextQuestionId) {
              return "No logic";
            }
            const nextQuestion = this.questionAnswers.find(q => q.id == option.nextQuestionId);
            if (nextQuestion) {
              if (nextQuestion.id == activityCompletionQuestion.id) {
                return "End activity";
              }
              const ordertext = question.stepSequence > nextQuestion.stepSequence ? "Back" : "Skip";
              return `${ordertext} to step ${nextQuestion.stepSequence}`;
            } else {
              return "No logic";
            }
          });
        }
      }
    },
    createActivitySteps(autoSave = false) {
      if (this.addQuestion) {
        if (!autoSave) {
          toastr.error("Please save or cancel your changes to continue.");
        }
      } else {
        if (this.updateActivityData !== null) {
          this.$api.updateActivity(this.activityId, this.updateActivityData).then(() => {
            if (!autoSave) {
              this.$toastr.success("Activity updated successfully");
              /** Route to Review Page */
              if (this.studyId) {
                this.$router.push({
                  name: "data-capture-form-activity-review",
                  params: {
                    activityId: this.activityId,
                    studyId: this.studyId,
                    taskId: this.taskId,
                    mode: this.mode
                  },
                  query: { mode: this.mode }
                });
              } else {
                this.$router.push({
                  name: "activity-review",
                  params: {
                    activityId: this.activityId,
                    taskId: this.taskId,
                    mode: this.mode
                  },
                  query: { mode: this.mode }
                });
              }
              /** Route to Review Page */
            }
          });
        } else {
          if (!autoSave) {
            /** Route to Review Page */
            if (this.studyId) {
              this.$router.push({
                name: this.$route.name == "data-capture-form-activity-questions" ? "data-capture-form-activity-review" : "study-activity-activity-review",
                params: {
                  activityId: this.activityId,
                  studyId: this.studyId,
                  mode: this.mode,
                  taskId: this.taskId,
                  revisionId: this.revisionId
                },
                query: { mode: this.mode }
              });
            } else {
              this.$router.push({
                name: "activity-review",
                params: {
                  activityId: this.activityId,
                  taskId: this.taskId,
                  mode: this.mode
                },
                query: { mode: this.mode }
              });
            }
            /** Route to Review Page */
          }
        }
      }
    },
    async skipForNow() {
      if (this.studyId) {
        // Back to study Config Activity Tab
        this.$router.push({
          name: this.$route.name == "data-capture-form-activity-questions" ? "forms-list" : "study-activities",
          params: { studyId: this.studyId }
        });
      } else {
        this.$router.push({
          name: "activity-library-homepage"
        });
      }
    },
    toggleTablet(val) {
      if (val == "phone") {
        this.showTablet = false;
      } else {
        this.showTablet = true;
      }
    },
    async checkBranchingLogic() {
      if (!this.batchDeleteQuestions.length) {
        toastr.error("Please select atleast one step to delete.");
        return false;
      }
      else if (this.isBranchingConfigured(this.batchDeleteQuestions) == true || this.isQuestionPartOfBranchingLogic(this.batchDeleteQuestions) || this.isBranchingLogicActivity()) {
        swal({
          title: "Please be advised that one of the activity has a branching logic set up. We suggest you review and revise it as needed. Would you like to continue?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#f16559",
          confirmButtonText: "Cancel",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            this.deleteSteps();
          } else {
            return false;
          }
        });
      } else {
        this.deleteSteps();
      }
    },
    deleteSteps() {
      let questionIds = [];
      swal({
        title: "Are you sure you want to delete these steps?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          questionIds = this.batchDeleteQuestions.map(que => que.id);
          this.$api.deleteActivitySteps(this.activityId, questionIds).then(() => {
            this.batchDeleteQuestions = [];
            this.getActivityDetails();
            toastr.success("Activity steps removed successfully.");
            this.showDeleteButton = false;
          });
        }
      });
    },
    updateDeleteFlag(flag) {
      this.showDeleteButton = flag;
      if (!flag) {
        this.batchDeleteQuestions = [];
      }
    },
    togglePreview() {
      this.$root.$emit("Toggle_Preview");
      if (this.showLogic == false) {
        if (this.showPreview == true) {
          this.showPreview = false;
        } else {
          this.showPreview = true;
        }
      }
    },
    toggleLogic() {
      if (this.showPreview == false) {
        if (this.showLogic == true) {
          this.showLogic = false;
        } else {
          this.showLogic = true;
        }
      }
    },
    //---------------export code START----------
    exportPdf() {
      const filename = "activity_" + this.activityId + ".pdf";
      html2canvas(document.querySelector("#questionbpodyy")).then(canvas => {
        const pdf = new jspdf("p", "mm", "a4");
        pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, 100, 100);
        pdf.save(filename);
      });
    },
    exportSurveyPdf() {
      this.generateSurveyPdf().then(pdf => {
        const filename = "activity_" + this.activityId + ".pdf";
        pdf.save(filename);
      });
    },
    async generateSurveyPdf() {
      let val;
      if (this.showTablet == true) {
        val = "#tablet-frame";
      } else {
        val = "#phone-frame";
      }
      return new Promise(async resolveComplete => {
        const pdf = new jspdf("p", "mm", "a4");
        for (let i = 0; i < this.questionAnswers.length - 1; i++) {
          await new Promise(async resolve => {
            this.nextMobileQuestionwithindex(i);
            await this.$nextTick();

            html2canvas(document.querySelector(val), {
              allowTaint: true,
              useCORS: true
            }).then(canvas => {
              if (val == "#phone-frame") {
                pdf.addImage(canvas.toDataURL("image/png"), "PNG", 50, 50, 100, 150);
              } else {
                pdf.addImage(canvas.toDataURL("image/png"), "PNG", 40, 50, 150, 150);
              }
              if (i < this.questionAnswers.length - 2) {
                pdf.addPage("a4", "p");
              }
              resolve();
            });
          });
        }
        resolveComplete(pdf);
      });
    },
    nextMobileQuestionwithindex(newIndex) {
      if (newIndex < this.questionAnswers.length - 1) {
        this.currentIndex = newIndex;
        this.phoneQuestion = this.questionAnswers[newIndex];
      }
    },
    //---------------------- export image--------------------------
    exportScreen() {
      let device;
      if (this.showTablet == true) {
        device = "tablet-frame";
      } else {
        device = "phone-frame";
      }
      const activityId = this.activityId;
      const container = document.getElementById(device);
      html2canvas(container, {
        allowTaint: true,
        useCORS: true,
        logging: true
      }).then(function(canvas) {
        () => false;
        const link = document.createElement("a");
        document.body.appendChild(link);
        const filename = "activity_" + activityId + ".png";
        link.download = filename;
        link.href = canvas.toDataURL("image/png");
        link.target = "_blank";
        link.click();
      });
    },
    //--------------- print screen------------------
    printScreen() {
      let val;
      if (this.showTablet == true) {
        val = "#tablet-frame";
      } else {
        val = "#phone-frame";
      }
      const container = document.querySelector(val);
      html2canvas(container, { allowTaint: true, useCORS: true }).then(function(canvas) {
        () => false;
        const dataURL = canvas.toDataURL();
        const width = canvas.width;
        const printWindow = window.open("");
        $(printWindow.document.body)
          .html("<img id='Image' src=" + dataURL + " style='" + width + "'></img>")
          .ready(function() {
            printWindow.focus();
            printWindow.print();
          });
      });
    },
    async printSurvey() {
      this.generateSurveyPdf().then(pdf => {
        pdf.autoPrint();
        window.open(pdf.output("bloburl"), "_blank");
      });
    },
    imgLoaded(imgElement) {
      return imgElement.complete && imgElement.naturalHeight !== 0;
    },
    ImagetoPrint(source) {
      return "<img src='" + source + "' />";
    },
    goBack() {
      window.history.back();
    },
    nextMobileQuestion() {
      if (this.currentIndex < this.questionAnswers.length - 2) {
        this.currentIndex++;
        this.phoneQuestion = this.questionAnswers[this.currentIndex];
      }
    },
    prevMobileQuestion() {
      if (this.currentIndex != 0) {
        this.currentIndex--;
        this.phoneQuestion = this.questionAnswers[this.currentIndex];
      }
    },
    pushCompletionQuestion() {
      //Removing default Completion Object if custom is Added in the Task Type
      if (this.questionAnswers.findIndex(item => item.subtype == "custom") != -1) {
        this.questionAnswers.splice(
          this.questionAnswers.findIndex(item => item.classType == "CompletionQuestion"),
          1
        );
      }

      const completionIndex = _.findIndex(this.questionAnswers, o => o.type === "SurveyCompletion");
      if (completionIndex >= 0) {
        const element = this.questionAnswers[completionIndex];
        this.questionAnswers.splice(completionIndex, 1);
        this.questionAnswers.push(element);
      } else {
        this.questionAnswers.push({
          classType: "CompletionQuestion",
          id: "",
          type: "SurveyCompletion",
          sequence: 100000,
          title: "Activity Complete!",
          information: "Activity completed successfully"
        });
      }
    },
    processQuestion(question) {
      question.map(function(value) {
        if (value.type == "SurveyInstruction") {
          if (value.formattedTitle == "") {
            value.formattedTitle = value.title;
          }
          if (value.formattedInformation == "") {
            value.formattedInformation = value.information;
          }
        } else if (value.type == "CustomScale" && value.formattedLabels == undefined) {
          value.formattedLabels = value.labels;
        } else {
          if (value.formattedBody == "") {
            value.formattedBody = value.body;
          }
          if (value.options !== undefined && value.options.formattedBody == "") {
            value.options.formattedBody = value.options.body;
          }
        }
      });
      return question;
    },
    getActivityDetails() {
      const revisionId = this.mode == "revise" || this.mode == "copy" ? "" : this.revisionId;
      this.$api.getActivityDetails(this.activityId, revisionId).then(
        response => {
          this.activityData = _.cloneDeep(response.data.result);
          this.activityData.questions = this.activityData.questions.map(o => {
            if (o.hasOwnProperty("stepSequence")) {
              return o;
            } else {
              o["stepSequence"] = o.sequence;
              return o;
            }
          });
          if (this.activityData && this.activityData.canScoreResponses == false) {
            this.isGroupScoringInEditMode = false;
          }
          if (this.updateActivityData != null && this.activityData.rows !== this.updateActivityData.rows) {
            this.activityData.rows = this.updateActivityData.rows;
          }
          this.$store.dispatch("setActivityDetailsAction", this.activityData);
          if (this.activityData.questions && this.activityData.questions.length > 0) {
            this.questionAnswers = this.processQuestion(this.activityData.questions);
            this.phoneQuestion = this.questionAnswers[this.currentIndex];
            this.questionsWithoutCompletion = _.filter(response.data.result.questions, o => o.type && o.type.toLowerCase() !== "surveycompletion");
            this.pushCompletionQuestion();
            this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
            const onlyQuestions = _.filter(response.data.result.questions, o => o.type && o.type.toLowerCase() !== "surveycompletion" && o.type);
            if (this.questionAnswers && onlyQuestions.length > 0) {
              this.addQuestion = false;
            }
            this.activityData.rows = response.data.result.rows;
          }

          if (this.questionAnswers && this.questionAnswers.length === 0) {
            this.addQuestion = true;
            this.addNewQuestion("SurveyInstruction");
          }
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while getting activity details";
          toastr.error(this.errorMsg);
        }
      );
    },
    updateActivityOldData(activityData) {
      return this.$api.updateActivity(this.activityId, _.cloneDeep(activityData));
    },
    updateActivityDataAction(activityData) {
      this.$api.updateActivity(this.activityId, _.cloneDeep(activityData)).then(() => {
        this.$toastr.success("Activity updated successfully");
      });
    },
    addNewStep(questionType) {
      if (this.addQuestion) {
        toastr.error("Please save or cancel your changes to continue.");
      } else {
        this.addNewQuestion(questionType);
      }
    },
    openCompletionScreen(questionType) {
      if (this.addQuestion) {
        toastr.error("Please save or cancel your changes to continue.");
      } else if (this.activityQuestions.findIndex(item => item.subtype == "custom") != -1) {
        return toastr.error("Only one completion screen is allowed for this activity, and it already exists.");
      } else {
        this.addNewQuestion(questionType);
        this.sampleQuestion.type = "SurveyCompletion";
      }
    },
    addNewQuestion(questionType) {
      this.sampleQuestion = _.cloneDeep(JSON.parse(JSON.stringify(sampleQuestionObj)));
      const questionsWithoutCompletion = _.filter(this.activityData.questions, o => o.type && o.type.toLowerCase() !== "surveycompletion");
      this.sampleQuestion.sequence = questionsWithoutCompletion.length ? Number(_.max(_.map(questionsWithoutCompletion, "sequence"))) + 1 : 1;
      this.sampleQuestion.questionNumber = this.questionAnswers.length;
      this.sampleQuestion.type = questionType;
      this.addQuestion = true;
      this.$nextTick(() => {
        this.smoothLandingOnScreen();
      });
    },
    smoothLandingOnScreen() {
      const element = document.getElementById("add-edit-question");
      element.scrollIntoView({
        block: "center",
        inline: "center",
        behavior: "smooth"
      });
    },
    toggleBranchingConfiguration(quesObj) {
      if (quesObj.type !== "Section") {
        return activityService.checkIfQuestionHasBranchingConfiguration(quesObj);
      } else {
        return false;
      }
    },
    questionIsEdited(index) {
      this.isQuestionInEditMode = true;
      this.currentIndex = index;
    },
    toggleGroupScoringEditMode() {
      this.isGroupScoringInEditMode = !this.isGroupScoringInEditMode;
      if (this.activityData && this.activityData.canScoreResponses == false) {
        this.isGroupScoringInEditMode = false;
      }
      if (!this.isGroupScoringInEditMode) {
        this.activeEditGroup = null;
        if (this.questionAnswers.length) {
          this.$store.dispatch("selectedActivityQuestionAction", { id: null });
        }
      }
    },
    onSectionAdd(sectionObj) {
      this.activeEditGroup = sectionObj;
    },
    checkAlreadyExist() {
      const found = obj => obj.subtype == "custom";
      if (!this.questionAnswers.some(found)) {
        return true;
      } else {
        return false;
      }
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.createActivitySteps(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    },
    isBranchingLogicActivity() {
      let branchingLogicEnabled = false;
      if (this.activityData.questions && this.activityData.questions.length > 0) {
        for (const questionIndex in this.activityData.questions) {
          const question = this.activityData.questions[questionIndex];
          if (question.branchingConfigured == true) {
            branchingLogicEnabled = true;
            break;
          }
        }
      }
      return branchingLogicEnabled;
    },
    isBranchingConfigured(questions) {
      let isBranching = false;
      questions.forEach(question => {
        isBranching = activityService.checkBranchingConfiguration(question);
      });
      if (isBranching) {
        return true;
      }
      return false;
    },
    isQuestionPartOfBranchingLogic(inputQuestions) {
      let isQuestionPartOfBranching = false;
      inputQuestions.forEach(inputQuestion => {
        if (this.activityData.questions && this.activityData.questions.length > 0) {
          for (const questionIndex in this.activityData.questions) {
            const question = this.activityData.questions[questionIndex];
            if (question.branchingConfigured == true) {
              if (question.nextQuestionId && question.nextQuestionId == inputQuestion.id) {
                isQuestionPartOfBranching = true;
              }
              if (question.recursiveLoopEndQuestionId && question.recursiveLoopEndQuestionId == inputQuestion.id) {
                //Covers MC MS Recursive branching.
                isQuestionPartOfBranching = true;
              }
              if (question.branchingOptions && question.branchingOptions.length > 0) {
                for (let i = 0; i < question.branchingOptions.length; i++) {
                  if (question.branchingOptions[i].nextQuestionId && question.branchingOptions[i].nextQuestionId == inputQuestion.id) {
                    isQuestionPartOfBranching = true;
                  }
                }
              }
              if (question.type.toLowerCase() !== "image" && question.options) {
                for (let i = 0; i < question.options.length; i++) {
                  if (question.options[i].nextQuestion && question.options[i].nextQuestion == inputQuestion.id) {
                    isQuestionPartOfBranching = true;
                  } else if (question.options[i].nextQuestionIdList && question.options[i].nextQuestionIdList.length) {
                    //Covers MC MS Recursive branching.
                    isQuestionPartOfBranching = true;
                  }
                }
              } else {
                if (question.languageImageOptions && question.languageImageOptions[0] && question.languageImageOptions[0].options) {
                  for (let i = 0; i < question.languageImageOptions[0].options.length; i++) {
                    if (question.languageImageOptions[0].options[i].nextQuestion && question.languageImageOptions[0].options[i].nextQuestion == inputQuestion.id) {
                      isQuestionPartOfBranching = true;
                    }
                  }
                }
              }
            }
          }
        }
      });
      if (isQuestionPartOfBranching) {
        return true;
      }
      return false;
    },
    getNextStepSequence() {
      const questionsWithoutCompletion = _.filter(this.activityData.questions, o => o.type && o.type.toLowerCase() !== "surveycompletion" && o.type.toLowerCase() !== "section");
      const stepSequence = Number(_.max(_.map(questionsWithoutCompletion, "stepSequence"))) + 1;
      return stepSequence;
    },
    getNextSequence() {
      const questionsWithoutCompletion = _.filter(this.activityData.questions, o => o.type && o.type.toLowerCase() !== "surveycompletion");
      const sequence = Number(_.max(_.map(questionsWithoutCompletion, "sequence"))) + 1;
      return sequence;
    },
    /* This method updates the sequence of ONLY actual questions-types (like, 'drop-down', 'yes no', etc) present in the questionList and escapes other items in questionList, like sections or placeholder dummy question-types like 'SurveyCompletion'. */
    getOrderedStepSequence(questionListOld) {
      let questionList = questionListOld;
      if (questionList) {
        let questionStepCounter = 0;
        questionList.forEach((question, index) => {
          if (!(this.isSection(question) || this.isSurveyCompletion(question))) {
            // If question-type is a any valid question of questionnaire.
            questionStepCounter++;
            question.sequence = index + 1;
            question.stepSequence = questionStepCounter;
          } else if (this.isSection(question)) {
            // If question-type is a section
            question.sequence = index + 1;
            question.stepSequence = index + 1;
          }
        });
      } else {
        questionList = [];
      }
      return questionList;
    },
    isSection(question) {
      if (question && question.type && question.type.toLowerCase() === "section") {
        return true;
      } else {
        return false;
      }
    },
    isSurveyCompletion(question) {
      if (question && question.type && question.type.toLowerCase() === "surveycompletion") {
        return true;
      } else {
        return false;
      }
    },
  },
  beforeDestroy() {
    this.stopAutoSave();
  }
};
</script>

<style scoped lang="scss">
.tags-page {
  font-family: "RobotoRegular";

  &__back-to-activites {
    color: #4c8ce4;
  }

  .container {
    max-width: 87%;
  }

  &__header {
    /* max-width: 90%; */
    margin: 100px auto 0 auto;

    &__add-tag-btn {
      width: 116px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #ffffff;
    }
  }

  .manage-tags-text {
    /* width: 105px; */
    height: 24px;
    font-family: "RobotoRegular";
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #000000;
  }

  .manage-tags-description {
    font-family: "RobotoRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: #000000;
  }

  .add-tag-modal {
    .modal-dialog {
      vertical-align: top !important;
      top: 100px;
    }

    &__container {
      width: 902px;
      height: 219px;
      border-radius: 4px;
      background-color: #ffffff;

      .fw-bold {
        font-weight: bold;
      }

      .color-black {
        color: black;
      }
    }

    &__name-input {
      width: 220px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__desc-input {
      width: 549px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__add-another-tag {
      font-family: "RobotoRegular";
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: normal;
      color: #4c8ce4;
      cursor: pointer;
    }

    &__save-tag-btn {
      width: 102px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      color: white;
    }
  }
}
a.disabled-footer {
  pointer-events: none;
  cursor: default;
}
.top-content-name {
  color: #000000;
  display: inline-block;
  width: 95%;
}
.tablet-dropdown {
  font-family: Roboto;

  font-size: 18px;

  font-weight: bold;

  font-stretch: normal;

  font-style: normal;

  line-height: 1.11;

  letter-spacing: normal;

  color: #666669;
}
.dropdown-toggle {
  cursor: pointer;
  font-family: RobotoBold;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #666669;
}

.phone-next-button {
  background-color: #576a6e;
  border: none;
  color: white;
  padding: 8px 21px;
  cursor: pointer;
  font-size: 15px;
  border-radius: 15px;
  width: 80%;
  margin-left: 45px;
}

.tablet-next-button {
  background-color: #576a6e;
  border: none;
  color: white;
  padding: 8px 21px;
  cursor: pointer;
  font-size: 15px;
  border-radius: 15px;
  width: 75%;
  margin-left: 60px;
}

.dwnd {
  align-items: center;
  display: flex;
  justify-content: center;
}
.Rectangle {
  width: 425px;
  height: 878px;
  background-color: rgba(196, 196, 196, 0.2);
}
.download-cancle {
  width: 43px;
  height: 20px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4c8ce4;
}

.download-btn {
  width: 136px;
  cursor: pointer;
  height: 30px;

  background-color: #4c8ce4;
}
.download-txt {
  width: 99px;
  height: 16px;
  padding: 5px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #ffffff;
}

.download-contant {
  width: 290px;
  margin-top: 308px;
  height: 20px;
  font-family: Roboto;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #000000;
}

.Export {
  width: 41px;
  height: 20px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #666669;
}
.Phone {
  width: 52px;
  height: 20px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.11;
  letter-spacing: normal;
  color: #666669;
  margin-top: 50px;
}

.add_Preview_btn {
  width: 148px;
  height: 36px;
  border-radius: 100px;
  border: solid 2px #4c8ce4;
  background-color: #ffffff;
}
.Content {
  width: 99px;
  height: 20px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4c8ce4;
}
.Ellipse {
  width: 30px;
  height: 30px;
  background-color: #4c8ce4;
}

body {
  color: #333;
}

.h2,
h2 {
  font-size: 30px;
  margin: 20px 0 10px;
}

.h3,
h3 {
  font-size: 24px;
  color: #333;
}

.h5,
h5 {
  font-size: 14px;
  margin: 10px 0;
}

.h6,
h6 {
  font-size: 12px;
  margin: 10px 0;
  color: #333;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-xs-10 {
  width: 83.33333333%;
}

.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.color_959fa4 {
  color: #959fa4 !important;
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .col-sm-4 {
    width: 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-12 {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
  .col-lg-offset-4 {
    margin-left: 33.33333333%;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

h1,
h2,
h3 {
  font-weight: 200;
}
.loader {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffffa1;
}
.loader .loader-container {
  margin: auto;
  text-align: center;
  vertical-align: middle;
  margin-top: calc(50vh - 30px);
  border: 0px solid;
  width: 118.4px;
  height: 118.4px;
  padding: 15px 15px 15px 15px;
  border-radius: 4px;
  -webkit-box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.45);
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.45);
  background-color: #ffffff;
}
.loader .loader-container .fa.fa-spin {
  font-size: 3em;
}
.phone-frame1 {
  border-radius: 29px;
  width: 308px;
  height: 554px;
  margin: 12% auto 0 auto;
  // margin-top: 12%;
  background-color: rgba(216, 216, 216, 0.4);
}
.phone-inner-part {
  border-radius: 8px;
  width: 294px;
  height: 507px;
  background-color: white;
  margin-left: 7px;
  margin-top: 1px;
  position: relative;
  top: 15px;
}
.phone-top-bar {
  height: 21px;
  padding: 5px;
  // background-color: black;
}
.tablet-frame1 {
  border-radius: 19px;
  width: 385px;
  height: 520.3px;
  margin: 12% 0 0 0;
  background-color: rgba(216, 216, 216, 0.4);
}
.tablet-inner-part {
  border-radius: 8px;
  width: 365px;
  height: 476px;
  background-color: white;
  margin-left: 10px;
  margin-top: 3px;
  position: relative;
  top: 15px;
}

.tablet-inner-part .bs-example-modal .modal-body {
  height: auto;
  overflow: hidden;
}

.question-body {
  width: 355px;
  height: 350px;
}

.form-control {
  border-radius: 2px;
}

.pr-0 {
  padding-right: 0;
}

.pl-0 {
  padding-left: 0;
}

.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

.text-style {
  color: #969090;
  text-align: right;
}

.btn-style {
  margin-top: 10px;
  width: 80px;
  height: 29px;
  margin-bottom: 50px;
}

.custom-btn {
  background: #00baf9;
  color: #fff;
  width: 220px;
}

.custom-para {
  padding-bottom: 20px;
  font-size: 20px;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.btn-disabled {
  color: white;
  background-color: #c6c2c2;
  border: #c6c2c2;
}

.text-color {
  color: #888;
}

.survey-name {
  color: #00baf9;
  font-size: 20px;
}

.pad-left50 {
  padding-left: 50px;
}

.button-blue-1 {
  background: #00bae0;
  color: #fff;
}

.button-blue-2 {
  background-color: #0197eb;
  color: #fff;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.mar-bot0 {
  margin-bottom: 0px !important;
}

.first_question_selection {
  img {
    width: 100%;
    max-width: 100px;
  }
  .header {
    font-size: 24px;
    font-weight: 200;
    padding: 14px;
  }
  .label_text {
    font-size: 18px;
    padding-bottom: 10px;
    font-weight: 400;
  }
  select {
    margin: auto;
    width: 100%;
    max-width: 300px;
  }
}

.question_count {
  background-color: #34537d;
  color: #fff;
  width: 25px;
  display: inline-block;
  border-radius: 10px;
  text-align: center;
}

.inner-card {
  border: 1px solid #ddd;
  box-shadow: 1px 0px 1px 1px #ddd;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f6fafc;
}

.select-style {
  background: #f9f9f9;
  border-radius: 2px;
}

.radio-style {
  margin-top: 5px !important;
  font-size: 14px;
  color: #555555;
}

.check-style {
  margin-top: 5px !important;
  font-size: 14px;
  color: #555555;
  padding: 0px 20px;
}

.border-left {
  border-left: 1px solid #555555;
}

.container-style {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
.container-stylee {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 29% !important;
  max-width: 29% !important;
  right: 0;
}
.container-style-logic {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  width: 26% !important;
  max-width: 29% !important;
  right: 0;
  top: 75px;
}
.input-style {
  width: 45px;
  margin-left: 10px;
  background: #f9f9f9;
  display: initial;
  padding: 5px;
}

.char-style {
  font-size: 14px;
  color: #555555;
}

.card {
  padding: 15px;
  color: black;
}

.add_another_btn {
  width: 136px;
  border-color: #4c8ce4;
  margin-bottom: 20px;
  background-color: #4c8ce4;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;

  .fa {
    position: relative;
    left: -35px;
    pointer-events: none;
    color: #4c8ce4;
    background-color: #fff;
    border-color: #fff;
  }
}

.preview-btn {
  background-color: #d4f2ff;
  width: 100%; // max-width: 150px;
  padding: 10px 0;
}

.icon-style {
  font-size: 47px;
  position: absolute;
  left: 30px;
  /* bottom: 0px; */
  top: -25px;
}

.pl-25 {
  padding-left: 25px;
}

@media (max-width: 575px) {
  .container-padding {
    padding-left: 20px;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
}

@media (min-width: 768px) and (max-width: 991px) {
}

@media (min-width: 992px) and (max-width: 1199px) {
}

@media (min-width: 1200px) {
}

.back_link {
  color: #666669;
}

.btn-new {
  width: 130px;
  height: 30px;
  background-color: #4c8ce4;
  border: none;
  border-radius: 100px;
}

.btn-delete {
  background-color: #4c8ce4;
  border: none;
  border-radius: 100px;
  left: 0px;
  height: 30px;
}
.add-complete-screen {
  width: 250px;
  height: 30px;
  color: #4c8ce4;
  background-color: white;
  border: 1px solid #4c8ce4;
  border-radius: 100px;
}

.btn-preview {
  background-color: #4c8ce4;
  border: none;
  border-radius: 4px;
}

.show-btn-preview {
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #c5d1d6;
  color: #4c8ce4;
}

.circle {
  width: 24px;
  height: 24px;
  background-color: #fff;
  position: relative;
  left: -20px;
  top: -3px;
  color: #4c8ce4;
  font-weight: bold;
  border-radius: 12px;
  font-size: 18px;
  padding: 0px 8px;
}

.delete-circle {
  width: 24px;
  height: 24px;
  background-color: #fff;
  position: relative;
  right: 10px;
  bottom: 2px;
  color: #4c8ce4;
  font-weight: bold;
  border-radius: 12px;
  font-size: 18px;
  padding: 0px 8px;
}
.add-complete-circle {
  width: 24px;
  height: 24px;
  background-color: #4c8ce4;
  position: relative;
  left: -20px;
  top: -3px;
  color: white;
  font-weight: bold;
  border-radius: 12px;
  font-size: 18px;
  padding: 0px 8px;
}

.show-circle {
  background-color: #b0bac9;
  position: relative;
  left: -8px;
  top: 0px;
  color: #ffffff;
  font-weight: bold;
  border-radius: 3px;
  font-size: 18px;
  padding: 5px 10px;
}

.hide-circle {
  width: 30px;
  height: 30px;
  background-color: #fff;
  position: relative;
  left: -8px;
  top: 0px;
  color: #4c8ce4;
  font-weight: bold;
  border-radius: 4px;
  font-size: 18px;
  padding: 5px 10px;
}
.txt {
  position: relative;
  color: #fff;
  bottom: 4px;
  left: -3px;
  font-size: 12px;
}
.hide-txt {
  position: relative;
  color: #fff;
  left: -8px;
  top: -2px;
  font-size: 14px;
}

.show-txt {
  position: relative;
  color: #4c8ce4;
  left: -5px;
  top: -2px;
  font-size: 14px;
  line-height: 1.43;
}

.phone-question {
  height: 350px;
  max-height: 350px;
}
.phone-question-footer {
  height: auto;
}
.tablet-question {
  height: 318px;
  max-height: 318px;
}
.tablet-question-footer {
  height: auto;
}
.tablet-question-footer .next-button {
  width: 80%;
  border-radius: 10px;
}
.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 80px;
  position: relative;
  z-index: 2;
  max-height: 80px;
  padding-right: 5px;
  background-color: #fff;
}
.instruction_title {
  word-break: keep-all;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
}
.instruction_info {
  word-break: keep-all;
  height: auto;
  width: auto;
  display: inline-block;
  float: left;
  background-color: #fff;
  z-index: 1;
  position: relative;
  max-width: 64%;
  padding-right: 10px;
}

.option-section {
  &:after {
    content: "";
    clear: both;
    display: block;
  }
  .col-sm-3 {
    float: left;
  }
}

.input-text {
  width: 100%;
  border-radius: 2px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.date-input {
  border-radius: 20px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.next-button {
  background-color: #4c6473;
  color: #fff;
  margin: 0 auto;
  display: block;
  width: 80%;
  border-radius: 10px;
}
.mobile-pagination {
  padding: 5px 10px 5px 10px;
  margin-bottom: 20px;
  border: 1px solid #e6e5e5;
  color: #bdbdbd;
}
.preview-footer {
  margin-top: 5%;
}
.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}
.modal-title {
  font-size: 24px !important;
}
.modal-dialog {
  width: 100%;
}
.bs-example-modal .modal-body {
  height: 215px;
  overflow: hidden;
}
.bs-example-modal .modal-header {
  padding: 0rem 1rem;
}
.bs-example-modal .modal-dialog {
  margin: 0rem auto;
}
.bs-example-modal .modal-body .vertical-vue-slider {
  height: 200px !important;
}
.phoneBar {
  font-family: RobotoBold;
  font-size: 18px;
  font-weight: bold;
  color: #666669;
  background-color: white;
  border: none;
  width: auto;
  padding-right: 10px;
}

.phoneTabletMenu .dropdown-toggle::after {
  margin-left: 5px;
}
.phoneTabletMenu .dropdown-toggle::after {
  margin-left: 5px;
  vertical-align: middle;
}
.exportBtn .dropdown-toggle::after {
  font-size: 18px;
  vertical-align: middle;
}
.phoneBar:focus {
  outline: #eee0 auto 1px;
  box-shadow: none;
}
.exportDropdown .dropdown-item {
  padding: 7px;
  font-family: RobotoRegular;
}
.exportDropdown .dropdown-item .fa,
.exportDropdown .dropdown-item .fas {
  color: #a8b0b4;
  margin-right: 5px;
}
.dropdown-item:hover {
  cursor: pointer;
}
.dropdown-item:ac {
  cursor: pointer;
}
.phone-tablet-menu .fa {
  margin-right: 10px;
}
.dropdown-menu {
  box-shadow: 0 0 0.5rem rgba(108, 118, 134, 0.5);
  min-width: 9rem;
}
.phone-tablet-menu a {
  padding: 5px 10px;
}
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #545b62;
}
.imageBox {
  height: 80px;
  width: 80px;
  margin: 0 auto;
}
.continue-btn {
  width: 122px;
  height: 36px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 100px;
  border: solid 2px #4c8ce4;
  outline: none;
}
.continue-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}
.cancel-btn {
  width: 122px;
  height: 36px;
  background-color: #ffffff !important;
  border-radius: 100px;
  border: solid 2px #ffffff !important;
  cursor: pointer;
  outline: none;
}
.cancel-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4c8ce4;
}
.branching-logic-text {
  font-size: 18px;
  font-weight: bold;
  color: #666669;
}
.logic-box {
  width: 32%;
  position: relative;
  background-color: #d3dee3;
  z-index: 1;
  padding: 2px 10px 2px 5px;
  height: max-content;
  font-size: 12px;
  color: #000;
  white-space: nowrap;
}
.logic-box-end-activity {
  width: 32%;
  position: relative;
  background-color: #fbe97f;
  z-index: 1;
  padding: 2px 2px 2px 5px;
  white-space: nowrap;
  height: max-content;
}
.logic-box-skip-back-activity {
  width: 32%;
  position: relative;
  background-color: #95e9bb;
  z-index: 1;
  padding: 2px 5px 2px 5px;
  white-space: nowrap;
  height: max-content;
}
.branching-question-name {
  font-size: 18px;
  color: #666669;
  width: 100%;
  background-color: #fff;
  position: relative;
  float: left;
  margin-bottom: 1rem;
  z-index: 1;
  .see-more-less {
    color: #4c8ce4;
    font-size: 14px;
    font-family: Roboto-Bold;
    display: block;
    margin-left: 6px;
  }
}
.answer-show-logic {
  display: block;
  width: 100%;
  clear: both;
}
.logical-frame-section {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  padding-bottom: 10px;
  height: auto;
  clear: both;
}
.logical-frame-section:last-child {
  border-bottom: none;
}
.branching-logic-answer-label {
  position: relative;
  z-index: 1;
  background-color: #fff;
  padding-right: 10px;
  white-space: nowrap;
}
.multichoice-ans {
  white-space: normal;
}
.group-scoring-enabled {
  background-color: #4c8ce4;
  color: #ffffff;
  border: solid 1px #c5d1d6;
}

.group-scoring-disabled {
  background-color: #ffffff;
  color: #4c8ce4;
  border: solid 1px #c5d1d6;
}
.logic-box-text {
  font-size: 12px;
  color: #000000;
}
.branching-steps-wrap {
  vertical-align: middle;
  position: relative;
  padding: 10px 0;
  display: flex;
  width: 100%;
}
.branching-steps-wrap .branching-question-name {
  width: 100%;
  padding-right: 5px;
  margin-bottom: 0px !important;
  visibility: hidden;
}

.show-logic-questions-wrap {
  position: relative;
}
.any-answer-label {
  position: relative;
  z-index: 1;
  display: inline-block;
}
.branching-steps-wrap:first-child .branching-question-name {
  visibility: visible;
  margin-bottom: 10px !important;
}
@media (min-width: 1800px) and (max-width: 2280px) {
  .survey_instruction_question {
    max-width: 84% !important;
  }
}
@media (min-width: 1600px) and (max-width: 1780px) {
  .survey_instruction_question {
    max-width: 79% !important;
  }
}
@media (min-width: 992px) and (max-width: 1300px) {
  .survey_instruction_question {
    max-width: 72% !important;
  }
}
@media (min-width: 2300px) and (max-width: 2560px) {
  .survey_instruction_question {
    max-width: 92% !important;
  }
}
@media (min-height: 710px) and (max-height: 720px) {
  .container-stylee {
    border-radius: 3px;
    background-color: #ffffff;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
    position: fixed;
    width: 29% !important;
    max-width: 29% !important;
    right: 0;
    height: 650px !important;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .container-stylee {
    scrollbar-width: thin;
    scrollbar-color: #c4c4c4 transparent;
  }
  .container-stylee::-webkit-scrollbar {
    width: 5px;
    border: 3px solid transparent;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  .container-stylee::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 20px;
    border: 2px solid transparent;
  }
  .container-stylee::-webkit-scrollbar-thumb:window-inactive {
    background-color: #c4c4c4;
    border-radius: 20px;
    border: 2px solid transparent;
  }
}
.suvey_question_card {
  max-width: 100%;
}

@media (max-height: 759px) {
  .container-stylee {
    border-radius: 3px;
    background-color: #ffffff;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
    position: fixed;
    width: 29% !important;
    max-width: 29% !important;
    right: 0;
    height: 550px;
    top: 75px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .container-stylee {
    scrollbar-width: thin;
    scrollbar-color: #c4c4c4 transparent;
  }
  .container-stylee::-webkit-scrollbar {
    width: 5px;
    border: 3px solid transparent;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  .container-stylee::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 20px;
    border: 2px solid transparent;
  }
  .container-stylee::-webkit-scrollbar-thumb:window-inactive {
    background-color: #c4c4c4;
    border-radius: 20px;
    border: 2px solid transparent;
  }
}

@media (min-height: 760px) and (max-height: 800px) {
  .container-stylee {
    border-radius: 3px;
    background-color: #ffffff;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
    position: fixed;
    width: 29% !important;
    max-width: 29% !important;
    right: 0;
    height: 725px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .container-stylee {
    scrollbar-width: thin;
    scrollbar-color: #c4c4c4 transparent;
  }
  .container-stylee::-webkit-scrollbar {
    width: 5px;
    border: 3px solid transparent;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  .container-stylee::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 20px;
    border: 2px solid transparent;
  }
  .container-stylee::-webkit-scrollbar-thumb:window-inactive {
    background-color: #c4c4c4;
    border-radius: 20px;
    border: 2px solid transparent;
  }
}
.loader .fa-spinner {
  font-size: 24px;
  color: #4c8ce4;
}
.arrow-division-line {
  height: 0.5px;
  align-self: stretch;
  flex-grow: 0;
  transform: rotate(-180deg);
  background-color: #000;
  line-height: 1px;
  padding: 0;
  margin: 0;
  display: flex;
  width: 100%;
  position: relative;
  top: 8px;
}
.line {
  height: 0.5px;
  align-self: stretch;
  flex-grow: 0;
  transform: rotate(-180deg);
  background-color: #000;
  line-height: 1px;
  padding: 0;
  margin: 0;
  display: flex;
  width: 100%;
  position: relative;
  top: 12px;
}
.branching-range-left {
  display: flex;
}
.selected-multichoice {
  display: flex;
  flex-wrap: wrap;
  margin-right: 15px;
}
.selected-multichoice-recursive {
  display: block;
  margin-right: 15px;
  white-space: nowrap;
  width: 100%;
}
.step-output-box {
  display: block;
  width: 100px;
}
.logic-box-update {
  font-size: 12px;
  color: #000;
  white-space: nowrap;
}
.branching-recursive {
  width: 100%;
}
.branching-text {
  padding-right: 15px;
}
.selected-recursive-chips {
  background: #95e9bb;
  padding-left: 5px;
}
.chip-recursive {
  width: 80px;
}
.branching-text-normal {
  padding: 2px 15px 2px 5px;
  width: 100px;
}
.and-sec {
  margin-right: 4px;
}
.chip-multiselect {
  margin-right: 4px;
}
.end-recursive-step {
  font-weight: bold;
}
</style>
